import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Banner } from "shared/components/banner/Banner";
import { Categorias } from "shared/components/categorias/Categorias";
import { Vitrine } from "shared/components/vitrine/Vitrine";
import { Produtos } from "shared/components/produtos/Produtos";
import { Buscador } from "shared/components/headers/headerbusca/buscador/Buscador";
import { ICategoria } from "shared/interfaces/ICategoria";
import { IProduto } from "shared/interfaces/IProduto";
import { listarProdutos } from "shared/services/api/produto.api";
import styles from "./Home.module.scss";

export const Home: React.FC = () => {
  const [categoriaSelecionada, setCategoriaSelecionada] = useState<ICategoria | null>(null);
  const [todosProdutos, setTodosProdutos] = useState<IProduto[]>([]);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.resetCategoria) setCategoriaSelecionada(null);
  }, [location.state]);

  useEffect(() => {
    let ativo = true;
    async function carregarProdutos() {
      setCarregandoProdutos(true);
      try {
        const resposta = await listarProdutos({ page: 1, limit: 100 });
        if (ativo) setTodosProdutos(resposta.produtos);
      } catch (erro) {
        console.error("Erro ao carregar produtos:", erro);
        if (ativo) setTodosProdutos([]);
      } finally {
        if (ativo) setCarregandoProdutos(false);
      }
    }
    carregarProdutos();
    return () => { ativo = false; };
  }, []);

  const produtosFiltrados = categoriaSelecionada
    ? todosProdutos.filter((produto) => String(produto.categoriaId) === String(categoriaSelecionada.id))
    : [];

  return (
    <div className={styles.page}>
      <div className={styles.containerBusca}><Buscador /></div>
      <Banner />
      <div className={styles.containerHome}>
        <div className={styles.containerCategorias}>
          <h3 className={styles.titulo}>Categorias</h3>
        </div>
        <Categorias onCategoriaClick={setCategoriaSelecionada} categoriaSelecionada={categoriaSelecionada} />
        {categoriaSelecionada ? (
          carregandoProdutos ? <p>Carregando produtos...</p> :
          produtosFiltrados.length > 0 ? <Produtos produtos={produtosFiltrados} /> :
          <p>Nenhum produto encontrado nesta categoria.</p>
        ) : <Vitrine />}
      </div>
    </div>
  );
};
